var React = require('react');

function Ellipse (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.30769 4C8.30769 6.20832 6.4471 8 4.15384 8C1.86059 8 -2.01035e-06 6.20832 -1.91011e-06 4C-1.80986e-06 1.79168 1.86059 -1.43701e-06 4.15384 -1.34048e-06C6.4471 -1.24395e-06 8.30769 1.79168 8.30769 4ZM22.1538 4C22.1538 6.20832 20.2933 8 18 8C15.7067 8 13.8462 6.20832 13.8462 4C13.8462 1.79168 15.7067 -8.54192e-07 18 -7.57664e-07C20.2933 -6.61135e-07 22.1538 1.79168 22.1538 4ZM36 4C36 6.20832 34.1394 8 31.8462 8C29.5529 8 27.6923 6.20832 27.6923 4C27.6923 1.79168 29.5529 -2.71374e-07 31.8462 -1.74845e-07C34.1394 -7.83168e-08 36 1.79168 36 4Z","fill":"black"}));
}

Ellipse.defaultProps = {"width":"36","height":"8","viewBox":"0 0 36 8","fill":"none"};

module.exports = Ellipse;

Ellipse.default = Ellipse;
